enum Disposition {
  Base = 1,
  JeuxRoleHomme = 2,
  JeuxRoleFemme = 3,
}

export { Disposition };
